exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".line-chart[data-v-3c42ac58] .el-rate__icon{font-size:4.26667vw;margin-right:.53333vw}", ""]);

// exports
